<template>
  <div class="dropdown admin-profile">
    <div
      class="d-xxl-flex align-items-center bg-transparent border-0 text-start p-0 cursor dropdown-toggle"
      data-bs-toggle="dropdown"
      aria-expanded="false"
    >
      <div class="flex-shrink-0">
        <img
          class="rounded-circle wh-40 administrator"
          src="@/assets/images/administrator.jpg"
          alt="admin"
        />
      </div>
      <div class="flex-grow-1 ms-2">
        <div class="d-flex align-items-center justify-content-between">
          <div class="d-none d-xxl-block">
            <div class="d-flex align-content-center">
              <h3>{{ userLogin?.user?.username }}</h3>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="dropdown-menu border-0 bg-white dropdown-menu-end">
      <div class="d-flex align-items-center info">
        <div class="flex-shrink-0">
          <img
            class="rounded-circle wh-30 administrator"
            src="@/assets/images/administrator.jpg"
            alt="admin"
          />
        </div>
        <div class="flex-grow-1 ms-2">
          <h3 class="fw-medium">{{ userLogin?.user?.name }}</h3>
          <span class="fs-12">{{ userLogin?.job?.name }}</span>
        </div>
      </div>

      <ul class="admin-link ps-0 mb-0 list-unstyled">
        <li>
          <RouterLink
            class="dropdown-item d-flex align-items-center text-body"
            :to="`/general/admin-profile/` + userLogin?.user?.id"
          >
            <i class="material-symbols-outlined">account_circle</i>
            <span class="ms-2">My Profile</span>
          </RouterLink>
        </li>
      </ul>

      <ul class="admin-link ps-0 mb-0 list-unstyled">
        <!-- <li>
          <RouterLink
            class="dropdown-item d-flex align-items-center text-body"
            to="/social/settings"
          >
            <i class="material-symbols-outlined">settings </i>
            <span class="ms-2">Settings</span>
          </RouterLink>
        </li> -->
        <li>
          <a
            class="dropdown-item d-flex align-items-center text-body"
            @click="actLogout"
            href="javascript:;"
          >
            <i class="material-symbols-outlined">logout</i>
            <span class="ms-2">Logout</span>
          </a>
        </li>
      </ul>
    </div>
  </div>
</template>

<script setup lang="ts">
import router from "@/router";
import { useAuthStore } from "@/stores/auth";
import { onMounted, ref } from "vue";
import { db } from "@/database/db";

const authStore = useAuthStore();
const userLogin = ref({});

onMounted(async () => {
  const { success } = await authStore.dispatchInitialize();
  let getData = await db.storage.get("login-info");
  userLogin.value = getData?.data;
});

const actLogout = async () => {
  await authStore.dispatchLogout();
  router.push("/");
};
</script>
